(function() { window.GUID_16412f57_8459_4d4c_b737_916680a8afde = { getGuid: function() { return "16412f57-8459-4d4c-b737-916680a8afde"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class FrozenAndManualCsrTooltip extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnBindEvents() {
                this.$Control.offon("click.frozen-and-manual-csr-tooltip-learn-more", this.handleLearnMoreClick.bind(this));
            }
            handleLearnMoreClick(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                const url = CS.Url.CSUrl("FrozenCSRExplanationModal");
                if (url) {
                    Controls.Popup.ShowAjaxModal(url, {}, () => { }, () => { }, true);
                }
            }
            OnDispose() { }
        }
        Controls.FrozenAndManualCsrTooltip = FrozenAndManualCsrTooltip;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=frozen-and-manual-csr-tooltip.js.map
